import { decode } from '../actions/jwt';

/** accessToken 만료 여부 (없거나 파싱 실패 시 만료로 간주) */
export function isAccessTokenExpired(accessToken) {
    if (!accessToken) return true;
    try {
        const decoded = decode(accessToken);
        return !decoded || (decoded.exp != null && decoded.exp < Date.now() / 1000);
    } catch {
        return true;
    }
}

/** localStorage 토큰으로 Redux auth 초기값·라우트 판단용 */
export function readStoredAuth() {
    if (typeof localStorage === 'undefined') {
        return { isLoggedIn: false, accessToken: null, refreshToken: null };
    }
    const accessToken = localStorage.getItem('accessToken');
    const refreshToken = localStorage.getItem('refreshToken');
    if (!accessToken || isAccessTokenExpired(accessToken)) {
        return { isLoggedIn: false, accessToken: null, refreshToken: null };
    }
    return { isLoggedIn: true, accessToken, refreshToken };
}

export function getMeInfoFromStorage() {
    if (typeof localStorage === 'undefined') return null;
    try {
        const s = localStorage.getItem('meInfo');
        return s ? JSON.parse(s) : null;
    } catch {
        return null;
    }
}
